import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetTask(taskId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/task/" + taskId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetTasks(start, limit, state, account) {
    const params = { start, limit };
    if (state) params.state = state;
    if (account) params.account = account;
    return axios.request({
        method: "get",
        url: getApiUrl() + "/task/",
        params,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetTasksByUser(userId, start, limit) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/task/by-user/" + userId,
        // params: { start, limit },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateTask(taskId, taskData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/task/" + taskId,
        data: taskData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSetTaskResponsible(taskId, responsible) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/task/" + taskId + "/responsible",
        data: { responsible },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSetTaskAssignees(taskId, assignees) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/task/" + taskId + "/assignees",
        data: { assignees },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateTask(taskData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/task",
        data: taskData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateTaskStatus(taskId, status, bypass = false) {
    const data = { status };
    if (bypass) data.bypass = true;
    return axios.request({
        method: "put",
        url: getApiUrl() + "/task/" + taskId + "/status",
        data,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteTaskAssignee(taskId, assignees) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/task/" + taskId + "/assignees",
        data: { assignees },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCompleteTask(taskId, bypass = false) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/task/" + taskId + "/complete",
        data: bypass ? { bypass: true } : {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestToggleTaskBoard(taskId, hasBoard) {
    return axios.request({
        method: "patch",
        url: getApiUrl() + "/task/" + taskId + "/board/toggle",
        data: { hasBoard },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetBoardCards(taskId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/task/" + taskId + "/board/cards",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAddBoardCard(taskId, payload) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/task/" + taskId + "/board/cards",
        data: payload || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateBoardCard(taskId, cardId, fields) {
    return axios.request({
        method: "patch",
        url: getApiUrl() + "/task/" + taskId + "/board/cards/" + cardId,
        data: fields,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestMoveBoardCardColumn(taskId, cardId, columnId) {
    return axios.request({
        method: "patch",
        url: getApiUrl() + "/task/" + taskId + "/board/cards/" + cardId + "/column",
        data: { columnId },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRemoveBoardCard(taskId, cardId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/task/" + taskId + "/board/cards/" + cardId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateBoardColumns(taskId, columns, baseColumns) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/task/" + taskId + "/board/columns",
        data: { columns, baseColumns },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAttachBoardCardAttachments(taskId, cardId, payload) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/task/" + taskId + "/board/cards/" + cardId + "/attachments",
        data: payload,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDetachBoardCardAttachment(taskId, cardId, attachmentId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/task/" + taskId + "/board/cards/" + cardId + "/attachments/" + attachmentId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRetryBoardCardPush(taskId, cardId, payload) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/task/" + taskId + "/board/cards/" + cardId + "/board-push",
        data: payload,
        // A comment carrying pictures is several BugHerd calls and an upload each, so this waits well past the minute the rest of the app allows: giving up early would report a
        // push that is still on its way.
        timeout: 180000,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAddChecklistItem(taskId, payload) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/task/" + taskId + "/checklist/items",
        data: payload || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRenameChecklistItem(taskId, itemId, name) {
    return axios.request({
        method: "patch",
        url: getApiUrl() + "/task/" + taskId + "/checklist/items/" + itemId,
        data: { name },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRemoveChecklistItem(taskId, itemId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/task/" + taskId + "/checklist/items/" + itemId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestToggleChecklistItem(taskId, itemId, completed) {
    return axios.request({
        method: "patch",
        url: getApiUrl() + "/task/" + taskId + "/checklist/items/" + itemId + "/toggle",
        data: { completed },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestImportTaskChecklist(taskId, checklistTemplateId) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/task/" + taskId + "/checklist/import",
        data: { checklistTemplateId },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateTaskBlockers(taskId, add, remove) {
    const data = {};
    if (Array.isArray(add) && add.length > 0) data.add = add;
    if (Array.isArray(remove) && remove.length > 0) data.remove = remove;
    return axios.request({
        method: "patch",
        url: getApiUrl() + "/task/" + taskId + "/blockers",
        data,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteTask(taskId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/task/" + taskId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRestoreTask(taskId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/task/" + taskId + "/restore",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSuggestedDueDate(project, responsible, hours) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/task/suggestedDueDate",
        params: { project, responsible, hours },
        withCredentials: true,
        crossorigin: true,
    });
}
